package navigation.home.dashboard

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.authentication.domain.repository.AuthRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.dashboard.ui.DashboardEvent
import com.essntl.features.dashboard.ui.DashboardState
import com.essntl.features.dashboard.ui.DashboardViewModel
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.itinerary.domain.use_case.UpdateItineraryServiceUseCase
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.task.domain.repository.TaskRepository
import com.essntl.features.task.domain.use_case.UpdateTaskUseCase

class DashboardScreenModel(
    authRepository: AuthRepository,
    taskRepository: TaskRepository,
    proposalRepository: ProposalRepository,
    itineraryRepository: ItineraryRepository,
    categoryRepository: CategoryRepository,
    profileRepository: ProfileRepository,
    updateTaskUseCase: UpdateTaskUseCase,
    loadingManager: LoadingManager,
) : StateScreenModel<DashboardState>(DashboardState()) {

    private val dashboardViewModel =
        DashboardViewModel(
            taskRepository = taskRepository,
            proposalRepository = proposalRepository,
            itineraryRepository = itineraryRepository,
            authRepository = authRepository,
            categoryRepository = categoryRepository,
            profileRepository = profileRepository,
            updateTaskUseCase = updateTaskUseCase,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: DashboardEvent) {
        dashboardViewModel.onEvent(event)
    }
}